module.exports = __webpack_public_path__ + "assets/19259df50ed10aa5e559aef9dfec7436.eot";